module.exports = __webpack_public_path__ + "img/estonia.43b3e7ae.svg";